<template>
  <div class="start contentLimiter flex flex-wrap -mx-2">
    <div class="hostlogo"><img :src="logo" /></div>
    <div class="hostcontent">
      <div v-html="startContent"></div>

      <div class="flex flex-wrap lg:flex-no-wrap">
        <div :class="columnClasses">
          <h3 class="mt-8 mb-6">Öffnungszeiten heute</h3>
          <div v-if="opentoday === null">Ruhetag</div>
          <ul class="mt-2" v-if="opentoday !== null">
            <li v-for="hour in opentoday" :key="hour.item_day + '_' + hour.item_open">
              {{ hour.item_open }} bis {{ hour.item_close }} Uhr
            </li>
          </ul>
        </div>

        <div :class="columnClasses">
          <h3 class="mt-8 mb-6">Bestellarchiv</h3>
          <router-link v-if="archivedOrdersCount > 0" tag="a" :to="{ name: 'Archiv' }" class="block my-2 text-black">{{ archivedOrdersCount }}+ Bestellungen im Archiv</router-link>
          <template v-if="archivedOrdersCount < 1">Du hast noch keine Bestellungen im Archiv</template>
        </div>

        <div :class="columnClasses">
          <h3 class="mt-8 mb-6">Abwesenheiten</h3>
          <ul v-if="away.length > 0">
            <li v-for="awayItem in away" :key="awayItem.item_start">
              <strong>{{ awayItem.item_title }}</strong><br />
              von {{ awayItem.item_start }} Uhr<br />
              bis {{ awayItem.item_stop }} Uhr
            </li>
          </ul>
          <template v-if="away.length === 0">Aktuell sind keine Abwesenheiten geplant</template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import endpoints from '../../endpoints'
import axios from 'axios'

export default {
  name: 'StartseiteCustomer',

  data () {
    return {
      hostId: window.hostId,
      logo: window.logo,
      startContent: window.startContent,
      opentoday: {},
      archivedOrdersCount: 0,
      away: []
    }
  },

  computed: {
    columnClasses () {
      return 'w-full lg:w-1/3'
    }
  },

  created () {
    this.getArchivedOrdersCount()

    axios.post(endpoints.hostopen, {
      'hostId': this.hostId
    })
      .then(response => {
        this.opentoday = response.data.opentoday
        this.away = response.data.away
      })
      .catch(e => {
        console.log(e)
      })
  },

  methods: {
    getArchivedOrdersCount () {
      axios.post(endpoints.archivedOrdersCount, { })
        .then(response => {
          this.archivedOrdersCount = response.data
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .hostlogo {
    width: 80%;
    text-align: center;

    @media (min-width: 576px) {
      width: 200px;
      margin-right: 20px;
      text-align: left;
    }
  }

  .hostcontent {
    width: 100%;

    @media (min-width: 576px) {
      width: calc(100% - 220px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/index-customer.vue